import * as React from "react";

function Comments(props) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.5 12H12.5V10H4.5V12ZM4.5 9H16.5V7H4.5V9ZM4.5 6H16.5V4H4.5V6ZM0.5 20V2C0.5 1.45 0.696 0.979002 1.088 0.587002C1.48 0.195002 1.95067 -0.000664969 2.5 1.69779e-06H18.5C19.05 1.69779e-06 19.521 0.196002 19.913 0.588002C20.305 0.980002 20.5007 1.45067 20.5 2V14C20.5 14.55 20.304 15.021 19.912 15.413C19.52 15.805 19.0493 16.0007 18.5 16H4.5L0.5 20ZM2.5 15.175L3.675 14H18.5V2H2.5V15.175Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoComments = React.memo(Comments);
export default MemoComments;
